// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "../../components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const Privacy = lazy(() => import ('../../containers/compliance/Privacy'));

function Page() {
  return (
    <Suspense fallback={<LoadingComponent />}>
        <OpenRoute><Privacy /></OpenRoute>
    </Suspense>
  );
}

export {Page};